import { render, staticRenderFns } from "./ModalEditClient.vue?vue&type=template&id=3f1b0967&"
import script from "./ModalEditClient.vue?vue&type=script&lang=js&"
export * from "./ModalEditClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports